const list = [
    {
        name: 'circle',
        title: '圈子',
        desc: '服务页、在玩服务',
        url: 'icon-line-circle_94a9ca89.svg',
        activeUrl: 'icon-fill-circle_3d85bac3.svg',
    },
    {
        name: 'dynamic',
        title: '动态/好友',
        desc: '服务页、在玩服务',
        url: 'icon-line-dynamic_99a84b8d.svg',
        activeUrl: 'icon-fill-dynamic_36894877.svg',
    },
    {
        name: 'competition',
        title: '电竞/直播',
        desc: '底部tab、服务页、在玩服务',
        url: 'icon-line-esports_3cad0b9d.svg',
        activeUrl: 'icon-fill-esports_04a108fb.svg',
    },
    {
        name: 'cup',
        title: '电竞',
        desc: '服务页、在玩服务',
        url: 'icon-line-event_70b3184d.svg',
        activeUrl: 'icon-fill-event_4297bbe0.svg',
    },
    {
        name: 'gift',
        title: '礼包/福利中心',
        desc: '首页、服务页、在玩服务',
        url: 'icon-line-gift_7594d9f3.svg',
        activeUrl: 'icon-fill-gift_d385b827.svg',
    },
    {
        name: 'live',
        title: '直播',
        desc: '服务页、在玩服务',
        url: 'icon-line-live_23957b04.svg',
        activeUrl: 'icon-fill-live_7188fa2c.svg',
    },
    {
        name: 'roles',
        title: '角色/攻略',
        desc: '首页、游戏分类',
        url: 'icon-line-roles_18b9c901.svg',
        activeUrl: 'icon-fill-roles_82ad188b.svg',
    },
    {
        name: 'battle',
        title: '战绩',
        desc: '服务页、在玩服务',
        url: 'icon-line-score_1c93c9e0.svg',
        activeUrl: 'icon-fill-score_04b58883.svg',
    },
    {
        name: 'rank',
        title: 'rank',
        desc: '首页中的游戏服务',
        url: 'icon-line-rank_fda5eb66.svg',
        activeUrl: 'icon-fill-rank_198aba50.svg',
    },
    {
        name: 'home',
        title: '首页',
        desc: '底部tab',
        url: 'icon-line-home_38958b10.svg',
        activeUrl: 'icon-fill-home_ee9bf927.svg',
    },
    {
        name: 'like',
        title: '好玩点赞',
        desc: '好玩社区',
        url: 'icon-line-like_fca149ae.svg',
        activeUrl: 'icon-fill-like_a298abe9.svg',
    },
    {
        name: 'comment',
        title: '评论',
        desc: '好玩社区',
        url: 'icon-line-comment_af850a6d.svg',
        activeUrl: 'icon-fill-comment_f591bb76.svg',
    },
    {
        name: 'me',
        title: '我',
        desc: '底部tab',
        url: 'icon-line-profile_da98e9f0.svg',
        activeUrl: 'icon-fill-profile_1d923abf.svg',
    },
    {
        name: 'video',
        title: '视频',
        desc: '服务页、在玩服务',
        url: 'icon-line-vedio_76a7eb50.svg',
        activeUrl: 'icon-fill-vedio_49bbf81d.svg',
    },
    {
        name: 'function',
        title: '功能',
        desc: '首页、游戏分类',
        url: 'icon-line-function_aab27a24.svg',
        activeUrl: 'icon-fill-function_69917905.svg',
    },
    {
        name: 'jiguang',
        title: '极光',
        desc: '首页、游戏分类',
        url: 'icon-line-jiguang_7393eb3f.svg',
        activeUrl: 'icon-fill-jiguang_2ea59b76.svg',
    },
    {
        name: 'all',
        title: '全部',
        desc: '首页、游戏分类',
        url: 'icon-line-all_659f19ff.svg',
        activeUrl: 'icon-fill-all_8b8cf8c1.svg',
    },
    {
        name: 'mini-game',
        title: '小游戏',
        desc: '首页、游戏分类',
        url: '20200611/171213/icon-line-minigame.svg',
        activeUrl: '20200611/171241/icon-fill-minigame.svg',
        customCdn: true,
    },
    {
        name: 'new-game',
        title: '新游',
        desc: '首页、游戏分类',
        url: '20200623/152236/icon-line-new-game.svg',
        activeUrl: '20200623/152226/icon-fill-new-game.svg',
        customCdn: true,
    },
    {
        name: 'action',
        title: '动作',
        desc: '首页、游戏分类',
        url: 'icon-line-Action_1db33a06.svg',
        activeUrl: 'icon-fill-Action_2d886819.svg',
    },
    {
        name: 'chess',
        title: '棋牌',
        desc: '首页、游戏分类',
        url: 'icon-line-chess_7cac3a60.svg',
        activeUrl: 'icon-fill-chess_908dc974.svg',
    },
    {
        name: 'creative',
        title: '创意小游戏',
        desc: '首页、游戏分类',
        url: 'icon-line-creative_cf9de958.svg',
        activeUrl: 'icon-fill-creative_9dae1880.svg',
    },
    {
        name: 'game',
        title: '游戏',
        desc: '首页、底部tab',
        url: 'icon-line-game_87903a97.svg',
        activeUrl: 'icon-fill-game_93a4abe9.svg',
    },
    {
        name: 'leisure',
        title: '休闲',
        desc: '首页、游戏分类',
        url: 'icon-line-leisure_209d4a67.svg',
        activeUrl: 'icon-fill-leisure_3da60a2c.svg',
    },
    {
        name: 'single-game',
        title: '单机',
        desc: '首页、游戏分类',
        url: 'icon-line-single-game_1b9d0a11.svg',
        activeUrl: 'icon-fill-single-game_f384196c.svg',
    },
    {
        name: 'privilege',
        title: '启动特权',
        desc: '启动特权、福利中心',
        url: 'icon-line-privilege_6cb8fab6.svg',
        activeUrl: 'icon-fill-privilege_53990b53.svg',
    },
    {
        name: 'hot',
        title: '热点',
        desc: '服务页、在玩服务',
        url: 'icon-line-hot_258e5a80.svg',
        activeUrl: 'icon-fill-hot_71a2db16.svg',
    },
    {
        name: 'cash',
        title: '现金券',
        desc: '首页',
        url: 'icon-line-Cash_5c9ccbf3.svg',
        activeUrl: 'icon-fill-Cash_af9e2860.svg',
    },
    {
        name: 'cash-narrow',
        title: '现金券缩略图',
        desc: '福利中心',
        url: 'icon-line-Cashnarrow_07938baa.svg',
        activeUrl: 'icon-fill-narrow_cbadebd2.svg',
    },
    {
        name: 'tasks',
        title: '幸运任务',
        desc: '福利中心-任务体系',
        url: 'icon-line-tasks_2bb3e995.svg',
        activeUrl: 'icon-fill-tasks_27b64840.svg',
    },
    {
        name: 'shop',
        title: '微信游戏商城',
        desc: '小程序-服务业-福利中心',
        url: 'icon-line-shop_98a409e5.svg',
        activeUrl: 'icon-fill-shop_4daaaa6e.svg',
    },
    {
        name: 'moment',
        title: '好玩',
        desc: '底部tab',
        url: 'icon-line-fun_a3bca9b2.svg',
        activeUrl: 'icon-fill-fun_25b9c923.svg',
    },
    {
        name: 'sport',
        title: '体育竞技',
        desc: '游戏分类',
        url: 'icon-line-sport_5eb67b00.svg',
        activeUrl: 'icon-fill-sport_82b26b9c.svg',
    },
    {
        name: 'strategy',
        title: '模拟策略',
        desc: '游戏分类',
        url: 'icon-line-Strategy_9a8f3823.svg',
        activeUrl: 'icon-fill-Strategy_d5ba5a09.svg',
    },
    {
        name: 'classic',
        title: '题材',
        desc: '游戏分类',
        url: 'icon-line-Classic_d798bbb4.svg',
        activeUrl: 'icon-fill-Classic_8f990a46.svg',
    },
    {
        name: 'search',
        title: '搜索',
        desc: '商城专区页、搜索页',
        url: 'icon-line-Search_879b2889.svg',
        activeUrl: 'icon-fill-Search_91804823.svg',
    },
    {
        name: 'weekly',
        title: '周报',
        desc: '数据首页',
        url: 'icon-line-weekly_609ee900.svg',
        activeUrl: 'icon-fill-weekly_a893d9e4.svg',
    },
    {
        name: 'addition',
        title: '金币/经验加成',
        desc: '启动特权',
        url: 'icon-line-addition_e49cf9ac.svg',
        activeUrl: 'icon-fill-addition_8397e8ff.svg',
    },
    {
        name: 'prerogative',
        title: '身份特权',
        desc: '启动特权',
        url: 'icon-line-prerogative_01991b7a.svg',
        activeUrl: 'icon-fill-prerogative_e4a058d6.svg',
    },
    {
        name: 'zan',
        title: '点赞',
        desc: '圈子点赞',
        url: 'icon-line-thumb_5c9c6b29.svg',
        activeUrl: 'icon-fill-thumb_0984489d.svg',
    },
    {
        name: 'share',
        title: '分享',
        desc: '分享',
        url: '20200928/150125/icon-line-share.svg',
        activeUrl: '20201214/105041/icon-fill-share.svg',
        customCdn: true,
    },
    {
        name: 'dawanjia',
        title: '大玩家',
        desc: '大玩家、福利中心',
        url: 'icon-line-dawanjia_77a4b94d.svg',
        activeUrl: 'icon-fill-dawanjia_04a4c9eb.svg',
    },
    {
        name: 'generalize',
        title: '推广员',
        desc: '服务页入口',
        url: 'icon-line-generalize_bdafdb13.svg',
        activeUrl: 'icon-fill-generalize_1d99dbee.svg',
    },
    {
        name: 'versions',
        title: '版本信息',
        desc: '详情页',
        url: 'icon-line-versions_80b27821.svg',
        activeUrl: 'icon-fill-versions_928dda1c.svg',
    },
    {
        name: 'bound',
        title: '绑定游戏',
        desc: '详情页',
        url: 'icon-line-bound_c09c39c1.svg',
        activeUrl: 'icon-fill-bound_96afa9bd.svg',
    },
    {
        name: 'offical-accounts',
        title: '公众号',
        desc: '公众号',
        url: 'icon-line-official-accounts_a98c5bbc.svg',
        activeUrl: 'icon-fill-official-accounts_2a9f3afa.svg',
    },
    {
        name: 'mini-program',
        title: '小程序、小游戏',
        desc: '小程序',
        url: 'icon-line-mini-program_42ab9a99.svg',
        activeUrl: 'icon-fill-mini-program_c495a818.svg',
    },
    {
        name: 'recently',
        title: '最近在玩',
        desc: '首页',
        url: 'icon-line-recently_118a68b0.svg',
        activeUrl: 'icon-fill-recently_c6bfdbae.svg',
    },
    {
        name: 'done',
        title: '完成',
        desc: '活动',
        url: 'icon-line-done_60bf98e5.svg',
        activeUrl: 'icon-fill-done_9ca3b830.svg',
    },
    {
        name: 'wechat-game',
        title: '微信游戏',
        desc: '微信游戏图标',
        url: 'icon-line-WeChat-game_b8a2bb9c.svg',
        activeUrl: 'icon-fill-Wechat-game_e9a06844.svg',
    },
    {
        name: 'identity',
        title: '身份认证',
        desc: '圈子',
        url: 'icon-line-identity_bc9209ca.svg',
        activeUrl: 'icon-fill-identity_6e87fa44.svg',
    },
    {
        name: 'help',
        title: '帮助',
        desc: '战绩组件/高光时刻',
        url: 'icon-line-help_21970814.svg',
        activeUrl: 'icon-fill-help_c49ea8c2.svg',
    },
    {
        name: 'more',
        title: '更多',
        desc: '首页/小游戏',
        url: 'icon-line-more_44ad7a73.svg',
        activeUrl: 'icon-fill-more_0d9168ce.svg',
    },
    {
        name: 'wechat-game-color',
        title: '微信游戏彩色logo',
        desc: '各种需要用到彩色logo的场景',
        url: 'icon-line-WeChat-game-color_cc984aa7.svg',
        activeUrl: 'icon-fill-WeChat-game-color_47b149eb.svg',
        origin: true,
    },
    {
        name: 'crown',
        title: '皇冠',
        desc: '新版动态',
        url: 'icon-fill-crown_c7b0abf4.svg',
        activeUrl: 'icon-fill-crown_c7b0abf4.svg',
    },
    {
        name: 'album',
        title: '相册',
        desc: '游戏圈',
        url: 'icon-line-album_7586f831.svg',
        activeUrl: 'icon-fill-album_8abc0831.svg',
    },
    {
        name: 'sticker',
        title: '表情',
        desc: '游戏圈',
        url: 'icon-line-sticker_199caa51.svg',
        activeUrl: 'icon-fill-sticker_ffa829ea.svg',
    },
    {
        name: 'at',
        title: '@人',
        desc: '评论组件、发表',
        url: 'icon-line-at_06bf39e5.svg',
        activeUrl: 'icon-fill-at_c183ca98.svg',
    },
    {
        name: 'keyboard',
        title: '键盘',
        desc: '评论组件',
        url: 'icon-line-keyboard_c2a85aec.svg',
        activeUrl: 'icon-fill-keyboard_11981b4f.svg',
    },
    {
        name: 'warning',
        title: '错误',
        desc: '游戏圈',
        url: 'icon-line-warning_10a3dab7.svg',
        activeUrl: 'icon-fill-warning_0ea09ba2.svg',
    },
    {
        name: 'friends',
        title: '朋友',
        desc: '小游戏排行榜',
        url: '20200423/icon-line-friends.svg',
        activeUrl: '20200423/icon-fill-friends.svg',
        customCdn: true,
    },
    {
        name: 'display',
        title: '显示',
        desc: '小游戏分类',
        url: '20200611/172048/icon-line-display.svg',
        activeUrl: '20200611/171306/icon-fill-display.svg',
        customCdn: true,
    },
    {
        name: 'list',
        title: '列表',
        desc: '小游戏分类',
        url: '20200611/172107/icon-line-list.svg',
        activeUrl: '20200611/172129/icon-fill-list.svg',
        customCdn: true,
    },
    {
        name: 'bellring',
        title: '通知',
        desc: '服务通知',
        url: '20200616/113119/icon-line-bellring.svg',
        activeUrl: '20200616/113110/icon-fill-bellring.svg',
        customCdn: true,
    },
    {
        name: 'unfold',
        title: '展开、收起',
        desc: '游戏圈',
        url: '20200622/145141/icon-line-unfold.svg',
        activeUrl: '20200622/145106/icon-fill-unfold.svg',
        customCdn: true,
    },
    {
        name: 'refresh',
        title: '刷新、重试',
        desc: '加载失败',
        url: '20200706/111300/icon-line-refresh.svg',
        activeUrl: '20200706/111252/icon-fill-refresh.svg',
        customCdn: true,
    },
    {
        name: 'add-2',
        title: '添加',
        desc: '个人主页',
        url: '20200708/095817/icon-line-add-2.svg',
        activeUrl: '20200708/095658/icon-fill-add-2.svg',
        customCdn: true,
    },
    {
        name: 'add',
        title: '添加',
        desc: '个人主页',
        url: '20200708/095851/icon-line-add.svg',
        activeUrl: '20200708/095901/icon-fill-add.svg',
        customCdn: true,
    },
    {
        name: 'chat',
        title: '私信',
        desc: '个人主页',
        url: '20200708/100019/icon-line-chat.svg',
        activeUrl: '20200708/100004/icon-fill-chat.svg',
        customCdn: true,
    },
    {
        name: 'say-hi',
        title: '打招呼',
        desc: '个人主页',
        url: '20200708/100128/icon-line-say-hi.svg',
        activeUrl: '20200708/100142/icon-fill-say-hi.svg',
        customCdn: true,
    },
    {
        name: 'transfer',
        title: '更换',
        desc: '个人主页',
        url: '20200708/100251/icon-line-transfer.svg',
        activeUrl: '20200708/100241/icon-fill-transfer.svg',
        customCdn: true,
    },
    {
        name: 'group',
        title: '群组、朋友',
        desc: 'feeds流',
        url: '20200713/202810/icon-line-group.svg',
        activeUrl: '20200713/202716/icon-fill-group.svg',
        customCdn: true,
    },
    {
        name: 'booking',
        title: '预约',
        desc: '弹窗',
        url: '20200720/111017/icon-line-booking.svg',
        activeUrl: '20200720/111059/icon-fill-booking.svg',
        customCdn: true,
    },
    {
        name: 'wifi',
        title: '无线局域网络',
        desc: 'wifi预约下载',
        url: '20200720/111249/icon-line-wifi.svg',
        activeUrl: '20200720/111321/icon-fill-wifi.svg',
        customCdn: true,
    },
    {
        name: 'eyes-on',
        title: '显示',
        desc: '在玩游戏列表',
        url: '20200721/200738/icon-line-eyes-on.svg',
        activeUrl: '20200721/200746/icon-fill-eyes-on.svg',
        customCdn: true,
    },
    {
        name: 'eyes-off',
        title: '隐藏',
        desc: '在玩游戏列表',
        url: '20200721/200727/icon-line-eyes-off.svg',
        activeUrl: '20200721/200716/icon-fill-eyes-off.svg',
        customCdn: true,
    },
    {
        name: 'dawanjia-2',
        title: '大玩家-2',
        desc: '个人主页',
        url: '20200731/192303/SVG/icon-line-dawanjia-2.svg',
        activeUrl: '20200806/145053/icon-fill-dawanjia-2.svg',
        customCdn: true,
    },
    {
        name: 'pencil',
        title: '编辑',
        desc: '个人主页',
        url: '20200731/192303/SVG/icon-line-pencil.svg',
        activeUrl: '20200731/192303/SVG/icon-fill-pencil.svg',
        customCdn: true,
    },
    {
        name: 'sinature',
        title: '签名',
        desc: '个人主页',
        url: '20201217/210820/icon-line-signature.svg',
        activeUrl: '20201217/210701/icon-fill-signature.svg',
        customCdn: true,
    },
    {
        name: 'male',
        title: '男性',
        desc: '个人主页',
        url: '20200804/153306/icon-fill-male-color.svg',
        activeUrl: '20200804/153306/icon-fill-male-color.svg',
        customCdn: true,
        origin: true,
    },
    {
        name: 'female',
        title: '女性',
        desc: '个人主页',
        url: '20200804/153038/icon-fill-female-color.svg',
        activeUrl: '20200804/153038/icon-fill-female-color.svg',
        customCdn: true,
        origin: true,
    },
    {
        name: 'new-game-2',
        title: '新游',
        desc: '首页、游戏分类',
        url: '20200813/112955/icon-line-new-game-2.svg',
        activeUrl: '20200813/112946/icon-fill-new-game-2.svg',
        customCdn: true,
    },
    {
        name: 'title-off',
        title: '不展示称号',
        desc: '个人主页',
        url: '20200814/162451/Icon-line-title-off.svg',
        activeUrl: '20200814/161519/icon-fill-title-off.svg',
        customCdn: true,
    },
    {
        name: 'title-on',
        title: '展示称号',
        desc: '个人主页',
        url: '20200814/162541/icon-line-title-on.svg',
        activeUrl: '20200814/162648/icon-fill-title-on.svg',
        customCdn: true,
    },
    {
        name: 'more-2',
        title: '更多',
        desc: '游戏圈',
        url: '20200914/114410/icon-line-more-2.svg',
        activeUrl: '20200914/114504/icon-fill-more-2.svg',
        customCdn: true,
    },
    {
        name: 'location',
        title: '地理位置',
        desc: '个人主页',
        url: '20200914/114644/icon-line-location.svg',
        activeUrl: '20200914/114602/icon-fill-location.svg',
        customCdn: true,
    },
    {
        name: 'score',
        title: '评价',
        desc: '游戏圈',
        url: '20200917/172216/icon-line-score.svg',
        activeUrl: '20200917/171932/icon-fill-score.svg',
        customCdn: true,
    },
    {
        name: 'done-2',
        title: '完成',
        desc: '订阅',
        url: '20201214/130838/icon-line-right.svg',
        activeUrl: '20201027/192432/icon-fill-right.svg',
        customCdn: true,
    },
    {
        name: 'channel',
        title: '视频号',
        desc: '圈子在玩',
        url: '20201029/110556/icon-line-channel.svg',
        activeUrl: '20201029/110613/icon-fill-channel.svg',
        customCdn: true,
    },
    {
        name: 'report-problem',
        title: '警告',
        desc: '消息提示',
        url: '20201112/164304/icon-line-report-problem.svg',
        activeUrl: '20201112/164152/icon-fill-report-problem.svg',
        customCdn: true,
    },
    {
        name: 'close',
        title: '关闭',
        desc: '控制',
        url: '20201113/141458/icon-line-close.svg',
        activeUrl: '20201113/141600/icon-fill-close.svg',
        customCdn: true,
    },
    {
        name: 'birthday',
        title: '生日',
        desc: '生日福利',
        url: '20201207/202009/icon-line-birthday.svg',
        activeUrl: '20201207/202125/icon-fill-birthday.svg',
        customCdn: true,
    },
    {
        name: 'data',
        title: '数据库',
        desc: '圈子服务页',
        url: '20201214/105532/icon-line-data.svg',
        activeUrl: '20201214/105746/icon-fill-data.svg',
        customCdn: true,
    },
    {
        name: 'face-maker',
        title: '捏脸',
        desc: '圈子服务页',
        url: '20201214/114415/icon-line-face-maker.svg',
        activeUrl: '20201214/110540/icon-fill-face-maker.svg',
        customCdn: true,
    },
    {
        name: 'tool',
        title: '辅助工具',
        desc: '圈子服务页',
        url: '20201214/114527/icon-line-tool.svg',
        activeUrl: '20201214/114614/icon-fill-tool.svg',
        customCdn: true,
    },
    {
        name: 'party',
        title: '活动',
        desc: '圈子服务页',
        url: '20201214/124443/icon-line-party.svg',
        activeUrl: '20201214/114858/icon-fill-party.svg',
        customCdn: true,
    },
    {
        name: 'contact',
        title: '通讯录',
        desc: '个人主页',
        url: '20201217/210942/icon-line-contact.svg',
        activeUrl: '20201217/211043/icon-fill-contact.svg',
        customCdn: true,
    },
    {
        name: 'loading',
        title: '加载',
        desc: '圈子',
        url: '20210312/152709/icon-line-loading.svg',
        activeUrl: '20210312/152700/icon-fill-loading.svg',
        customCdn: true,
    },
    {
        name: 'delete',
        title: '删除',
        desc: '圈子',
        url: '20210312/152721/icon-line-delete.svg',
        activeUrl: '20210312/152730/icon-fill-delete.svg',
        customCdn: true,
    },
    {
        name: 'personal-card',
        title: '个人卡片',
        desc: '个人主页',
        url: '20210323/150716/icon-line-personal-card.svg',
        activeUrl: '20210323/150419/icon-fill-signature.svg',
        customCdn: true,
    },
    {
        name: 'set',
        title: '设置',
        desc: '个人主页',
        url: '20210323/150849/icon-line-set.svg',
        activeUrl: '20210323/150911/icon-fill-set.svg',
        customCdn: true,
    },
    {
        name: 'mutual-follow',
        title: '互相关注',
        desc: '个人主页',
        url: '20210510/194213/icon-line-mutual-following.svg',
        activeUrl: '20210510/194357/icon-fill-mutual-following.svg',
        customCdn: true,
    },
    {
        name: 'follow',
        title: '关注',
        desc: '个人主页',
        url: '20210510/194443/icon-line-follow.svg',
        activeUrl: '20210510/194551/icon-fill-follow.svg',
        customCdn: true,
    },
    {
        name: 'tag',
        title: '标签',
        desc: '个人主页标签',
        url: '20210526/164746/icon-line-tag.svg',
        activeUrl: '20210526/164758/icon-fill-tag.svg',
        customCdn: true,
    },
    {
        name: 'chat-group',
        title: '圈层小组',
        desc: '聊天tab',
        url: '20210603/151319/icon-line-chat-group.svg',
        activeUrl: '20210706/153110/icon-fill-group.svg',
        customCdn: true,
    },
    {
        name: 'close2',
        title: '关闭',
        desc: '聊天tab',
        url: '20210607/111716/icon-line-close2.svg',
        activeUrl: '20210607/111802/icon-fill-close2.svg',
        customCdn: true,
    },
    {
        name: 'qr-code',
        title: '二维码',
        desc: '圈层信息页',
        url: '20210607/111706/icon-line-qr-code.svg',
        activeUrl: '20210607/111256/icon-fill-qr-code.svg',
        customCdn: true,
    },
    {
        name: 'link',
        title: '链接',
        desc: '个人页',
        url: '20210706/152842/icon-line-link.svg',
        activeUrl: '20210706/152853/icon-fill-link.svg',
        customCdn: true,
    },
];

export default {
    list,
};
